import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'footer-cmp',
  standalone: true,
  imports: [CommonModule],
  templateUrl: 'footer.component.html'
})

export class FooterComponent {
  date: Date = new Date();
}
